/** 좌표 계산.
 *
 * 예전에는 같은 Haversine 식이 화면마다 복사돼 있었습니다(9곳). 단위(m/km)와
 * 인자 모양(숫자 4개 / {lat,lng} 2개)만 조금씩 달라 서로 다른 함수처럼 보였을 뿐,
 * 계산은 전부 같았습니다. 여기 한 벌만 둡니다.
 */

export interface LatLng {
    lat: number;
    lng: number;
}

/** 두 좌표 사이 거리 (미터) */
export function haversineMeters(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371000;
    const toRad = (d: number) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2
        + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(a));
}

/** {lat,lng} 두 점 사이 거리 (미터) */
export const distanceM = (a: LatLng, b: LatLng): number =>
    haversineMeters(a.lat, a.lng, b.lat, b.lng);

/** {lat,lng} 두 점 사이 거리 (킬로미터) */
export const distanceKm = (a: LatLng, b: LatLng): number => distanceM(a, b) / 1000;
